var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { memo } from 'react';
import { useBlockEdit } from '../../';
import { Spinner } from '@web/utils';
import { styled } from '@web/theme';
export var SavingIndicator = memo(function () {
    var isSaving = useBlockEdit().blockEdit.isSaving;
    if (!isSaving)
        return null;
    return (React.createElement(Saving, null,
        React.createElement("div", null, "Ukl\u00E1d\u00E1m..."),
        React.createElement(Spinner, { color: "white" })));
});
var Saving = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\twidth: 100%;\n\theight: 100%;\n\tpadding: 1rem;\n\tbackground: rgba(0, 0, 0,.5);\n\tcolor: white;\n\tz-index: 585;\n\tdisplay: flex;\n\talign-items: flex-end;\n\tjustify-content: flex-end;\n\t\n\t> div\t{\n\t\tmargin-right: .5rem;\n\t}\n"], ["\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\twidth: 100%;\n\theight: 100%;\n\tpadding: 1rem;\n\tbackground: rgba(0, 0, 0,.5);\n\tcolor: white;\n\tz-index: 585;\n\tdisplay: flex;\n\talign-items: flex-end;\n\tjustify-content: flex-end;\n\t\n\t> div\t{\n\t\tmargin-right: .5rem;\n\t}\n"])));
var templateObject_1;
